import _ from "lodash";
import * as ROUTES from "../constants/routes";

// Function help to get the sidebar items config
const getSystemSidebarItems = (app) => {
  const tenkenSidebarItems = {
    "inspection": {
      text: "点検",
      icon: "sidebar-inspection",
      link: ROUTES.MACHINE_INPUT
    },
    'judgment': {
      text: "承認",
      icon: "sidebar-judgment",
      link: ROUTES.JUDGMENT,
    },
    'treatment': {
      text: "処置",
      icon: "sidebar-treatment",
      link: ROUTES.UNFINISHED_ACTION_LIST,
    },
    'inspection-status': {
      text: "点検状況",
      icon: "sidebar-inspection-status",
      link: ROUTES.INSPECTION_STATUS,
    },
    'inspection-sheet': {
      text: "点検表",
      icon: "sidebar-inspection-sheet",
      link: ROUTES.INSPECTION_SHEET,
    },
    'search': {
      text: "詳細検索",
      icon: "sidebar-search",
      link: ROUTES.SEARCH,
    },
    'master-top': {
      text: "マスタ更新",
      icon: "sidebar-master-top",
      link: ROUTES.MASTER_DASHBOARD,
    },
    "position-master-update": {
      text: "更新",
      icon: "sidebar-position-master-update",
      link: ROUTES.POSITION_MASTER_UPDATE,
    },
    "position-master-history-search": {
      text: "更新履歴検索",
      icon: "sidebar-position-master-history-search",
      link: ROUTES.POSITION_MASTER_HISTORY_SEARCH,
    },
    "position-master-import": {
      text: "インポート",
      icon: "sidebar-position-master-import",
      link: ROUTES.POSITION_MASTER_IMPORT,
    },
    "position-master-export": {
      text: "エクスポート",
      icon: "sidebar-position-master-export",
      link: ROUTES.POSITION_MASTER_EXPORT,
    },
    "machine-master-update": {
      text: "更新",
      icon: "sidebar-machine-master-update",
      link: ROUTES.MACHINE_MASTER_UPDATE,
    },
    "machine-master-history-search": {
      text: "更新履歴検索",
      icon: "sidebar-machine-master-history-search",
      link: ROUTES.MACHINE_MASTER_HISTORY_SEARCH,
    },
    "machine-master-import": {
      text: "インポート",
      icon: "sidebar-machine-master-import",
      link: ROUTES.MACHINE_MASTER_IMPORT,
    },
    "machine-master-export": {
      text: "エクスポート",
      icon: "sidebar-machine-master-export",
      link: ROUTES.MACHINE_MASTER_EXPORT,
    },
    "machine-master-group-update": {
      text: "グループ更新",
      icon: "sidebar-machine-master-group-update",
      link: ROUTES.MACHINE_MASTER_GROUP_UPDATE,
    },
    "department-master-update": {
      text: "更新",
      icon: "sidebar-department-master-update",
      link: ROUTES.DEPARTMENT_MASTER_UPDATE
    },
    'department-master-history-search': {
      text: "更新履歴検索",
      icon: "sidebar-department-master-history-search",
      link: ROUTES.DEPARTMENT_MASTER_HISTORY_SEARCH,
    },
    'department-master-import': {
      text: "インポート",
      icon: "sidebar-department-master-import",
      link: ROUTES.DEPARTMENT_MASTER_IMPORT,
    },
    'department-master-export': {
      text: "エクスポート",
      icon: "sidebar-department-master-export",
      link: ROUTES.DEPARTMENT_MASTER_EXPORT,
    },
    "approval-setting-master-update": {
      text: "更新",
      icon: "sidebar-position-master-update",
      link: ROUTES.APPROVAL_SETTING,
    },
    "approval-setting-master-history-search": {
      text: "更新履歴検索",
      icon: "sidebar-position-master-history-search",
      link: ROUTES.APPROVAL_SETTING_MASTER_SEARCH,
    },
    "approval-setting-master-import": {
      text: "インポート",
      icon: "sidebar-position-master-import",
      link: ROUTES.APPROVAL_SETTING_MASTER_IMPORT,
    },
    "approval-setting-master-export": {
      text: "エクスポート",
      icon: "sidebar-position-master-export",
      link: ROUTES.APPROVAL_SETTING_MASTER_EXPORT,
    },
    "inspection-template-master-update": {
      text: "更新",
      icon: "sidebar-position-master-update",
      link: ROUTES.TEMPLATE_MANAGEMENT,
    },
    "inspection-template-master-history-search": {
      text: "更新履歴検索",
      icon: "sidebar-position-master-history-search",
      link: ROUTES.INSPECTION_TEMPLATE_MASTER_SEARCH,
    },
    "inspection-template-master-import": {
      text: "インポート",
      icon: "sidebar-position-master-import",
      link: ROUTES.INSPECTION_TEMPLATE_MASTER_IMPORT,
    },
    "inspection-template-master-export": {
      text: "エクスポート",
      icon: "sidebar-position-master-export",
      link: ROUTES.INSPECTION_TEMPLATE_MASTER_EXPORT,
    },
  };

  const userMasterSidebarItems = {
    "user-master-update": {
      text: "マスタ更新",
      icon: "sidebar-user-update",
      link: ROUTES.USER_MASTER_UPDATE
    },
    'user-master-import': {
      text: "インポート",
      icon: "sidebar-user-import",
      link: ROUTES.USER_MASTER_IMPORT,
    },
    'user-master-export': {
      text: "エクスポート",
      icon: "sidebar-user-export",
      link: ROUTES.USER_MASTER_EXPORT,
    },
    'user-master-search': {
      text: "マスタ検索",
      icon: "sidebar-user-search",
      link: ROUTES.USER_MASTER_SEARCH,
    },
    'user-master-history-search': {
      text: "更新履歴検索",
      icon: "sidebar-user-update-history-search",
      link: ROUTES.USER_MASTER_HISTORY_SEARCH,
    },
  };

  switch (app) {
    case "tenken":
      return tenkenSidebarItems;
    case "user":
      return userMasterSidebarItems;
    default:
      return userMasterSidebarItems;
  }
};

// Function help to get sidebar item
const getSidebarItem = (app, name) => {
  const sidebarItems = getSystemSidebarItems(app);
  if (_.isEmpty(sidebarItems[name])) {
    return undefined;
  }
  return sidebarItems[name];
};

export { getSidebarItem };
